import Cookies from "js-cookie";

/**
 * Retrieves the JWT authentication token for the current site.
 * This function is used by the Apollo Client to add the Authorization header
 * to all GraphQL requests.
 * 
 * @returns The JWT token if available, null otherwise
 */
export function getAuthToken(): string | null {
  // For SSR, we need to handle the case where window is not available
  if (typeof window === "undefined") {
    return null;
  }

  // Get the JWT token from the cookie
  const token = Cookies.get(`be_${window.siteId}`);
  return token || null;
}